// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PointsProgressBar-module-pointsProgressBar-l4qBT{border-radius:9999px;border-radius:var(--des-radius-control-roundish, 9999px);background:#202020;background:var(--des-color-fill-control-base, #202020);width:100%;height:6px;margin-bottom:10px;margin-bottom:var(--des-dimension-gap-and-padding-general-near-large, 10px)}.PointsProgressBar-module-pointsProgressBar-l4qBT .PointsProgressBar-module-pointsProgressBarFill-1bYYt{border-radius:9999px;border-radius:var(--des-radius-control-roundish, 9999px);background:#3567ff;background:var(--des-color-fill-control-accent, #3567ff);height:100%}", ""]);
// Exports
exports.locals = {
	"pointsProgressBar": "PointsProgressBar-module-pointsProgressBar-l4qBT",
	"pointsProgressBarFill": "PointsProgressBar-module-pointsProgressBarFill-1bYYt"
};
module.exports = exports;
